module.exports = __webpack_public_path__ + "img/company-honor-MHRA-20241028.33d632b2.jpg";